import * as licenseApi from "../../../../apis/licenseApi";
import {companyApiKeysSlice, callTypes} from "./companyApiKeysSlice";
import {toast} from "react-toastify";

const {actions} = companyApiKeysSlice;

export const fetchCompanyApiKeys = queryParams => dispatch => {
  dispatch(actions.startCall());
  return licenseApi
    .filterCompanyApiKeys(queryParams)
    .then(response => {
      const {totalElements: totalCount, data: companyApiKeyItems} = response;
      dispatch(actions.companyApiKeysFetched({totalCount, companyApiKeyItems}));
    })
    .catch(error => {
      error.clientMessage = "Can't find Company API Keys";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const fetchCompanyApiKeyFilterOptions = resellerId => dispatch => {
  return licenseApi
    .getCompanyApiKeyFilterOptions(resellerId)
    .then(filterOptions => {
      dispatch(actions.filterOptionsFetched(filterOptions));
    })
    .catch(() => {
      dispatch(actions.filterOptionsFetched({companies: [], resellers: []}));
    });
};

export const resetCompanyApiKeysState = () => dispatch => {
  dispatch(actions.resetState());
};

export const revokeCompanyApiKey = id => () => {
  return licenseApi
    .revokeCompanyApiKey(id)
    .then(response => {
      toast.success("Revoke Company API Key Successfully!");
      return response;
    })
    .catch(() => false);
};

export const reactivateCompanyApiKey = id => () => {
  return licenseApi
    .reactivateCompanyApiKey(id)
    .then(response => {
      toast.success("Reactivate Company API Key Successfully!");
      return response;
    })
    .catch(() => false);
};
